<h1>{{card.title | translate}}</h1>
<h2>{{'m1-m2.sprint7.cockpit.card.pruefung-der-variablen.subtitle.1' | translate}}</h2>
<!-- table 1 -->
<app-chart-download-button (buttonClick)="downloadTable()">
  <h3 translate>sprint9.cockpit.card.all.tabelle</h3>
</app-chart-download-button>

<div class="table-wrapper">
  @if (pruefungDerVariablen) {
    <table class="hover-focus" id="pruefungDerVariablenVerteilungProVariableM2">
      <thead>
        <tr>
          <th scope="col" class="no-border"><br></th>
          <th scope="col" rowspan="2" class="header bold centered border-bold-left border-bold-right">
            <span class="strong">{{'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.min' | translate
            }}</span>
          </th>
          <th scope="col" rowspan="2" class="header bold centered border-bold-left">
            <span class="strong">{{'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.quartil.1' | translate
            }}</span>
          </th>
          <th scope="col" rowspan="2" class="header bold centered border-bold-left">
            <span class="strong">{{'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.median' | translate
            }}</span>
          </th>
          <th scope="col" rowspan="2" class="header bold centered border-bold-left">
            <span class="strong">{{'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.durchschnitt' |
            translate }}</span>
          </th>
          <th scope="col" rowspan="2" class="header bold centered border-bold-left">
            <span class="strong">{{'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.quartil.3' | translate
            }}</span>
          </th>
          <th scope="col" rowspan="2" class="header bold centered border-bold-left border-bold-right">
            <span class="strong">{{'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.max' | translate
            }}</span>
          </th>
        </tr>
        <tr>
          <th scope="col" class="header bold centered border-bold-left border-bold-right"><br></th>
        </tr>
      </thead>
      <tbody>
        <tr appPruefungDerVariablenTableRow [rowdata]="pruefungDerVariablen.Alter"
          [rowHeader]="'m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.alter'" [crtLocale]="crtLocale"
          [minFractioningDigits]="1">
        </tr>
        <tr appPruefungDerVariablenTableRow [rowdata]="pruefungDerVariablen.AlterPlafoniert"
          [rowHeader]="'m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.alter-15-plafoniert'"
          [crtLocale]="crtLocale" [minFractioningDigits]="1">
        </tr>
        <tr appPruefungDerVariablenTableRow [rowdata]="pruefungDerVariablen.Dienstjahre"
          [rowHeader]="'m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.dienstjahre'" [crtLocale]="crtLocale"
          [minFractioningDigits]="1">
        </tr>
        <tr appPruefungDerVariablenTableRow [rowdata]="pruefungDerVariablen.DienstjahrePlafoniert"
          [rowHeader]="'m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.dienstjahre-plafoniert'"
          [crtLocale]="crtLocale" [minFractioningDigits]="1">
        </tr>
        <tr appPruefungDerVariablenTableRow [rowdata]="pruefungDerVariablen.AnMonatslohnBeschaeftigungsgrad"
          [rowHeader]="'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.beschaeftigungsgrad'"
          [crtLocale]="crtLocale" [minFractioningDigits]="1">
        </tr>
        <tr appPruefungDerVariablenTableRow
          [rowdata]="pruefungDerVariablen.AnStundenlohnAnzahlBezahlteStundenImReferenzmonat"
          [rowHeader]="'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.anzahlBezahlteStunden'"
          [crtLocale]="crtLocale" [minFractioningDigits]="1">
        </tr>
        <tr appPruefungDerVariablenTableRow [rowdata]="pruefungDerVariablen.Grundlohn"
          [rowHeader]="'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.grundlohn'" [crtLocale]="crtLocale"
          [minFractioningDigits]="1">
        </tr>
        <tr appPruefungDerVariablenTableRow [rowdata]="pruefungDerVariablen.Zulagen"
          [rowHeader]="'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.zulage'" [crtLocale]="crtLocale"
          [minFractioningDigits]="1">
        </tr>
        <tr appPruefungDerVariablenTableRow [rowdata]="pruefungDerVariablen.DreizehnterMonatslohn"
          [rowHeader]="'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.monatslohn13'" [crtLocale]="crtLocale"
          [minFractioningDigits]="1">
        </tr>
        <tr appPruefungDerVariablenTableRow [rowdata]="pruefungDerVariablen.Sonderzahlungen"
          [rowHeader]="'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.sonderzahlungen'"
          [crtLocale]="crtLocale" [minFractioningDigits]="1">
        </tr>
        <tr appPruefungDerVariablenTableRow [rowdata]="pruefungDerVariablen.StandardisierterGesamtVerdienst"
          [rowHeader]="'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.gesamtverdienst'"
          [crtLocale]="crtLocale" [minFractioningDigits]="1">
        </tr>
        <tr appPruefungDerVariablenTableRow [rowdata]="pruefungDerVariablen.BetrieblicheWoechentlicheArbeitszeit"
          [rowHeader]="'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.buwazInStunden'"
          [crtLocale]="crtLocale" [minFractioningDigits]="1">
        </tr>
        <tr appPruefungDerVariablenTableRow [rowdata]="pruefungDerVariablen.Funktionswert"
          [rowHeader]="'m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.funktionswert'" [crtLocale]="crtLocale"
          [minFractioningDigits]="1">
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td class="hint" colspan="7">
            {{'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table1.hinveise-grundgesamtheit-gueltig' |
          translate}}</td>
        </tr>
      </tfoot>
    </table>
  }
</div>

<div style="height: 60px"></div>

<h2>{{'m1-m2.sprint7.cockpit.card.pruefung-der-variablen.subtitle.2' | translate}}</h2>

@if (pruefungDerVariablen) {
  <app-effektive-ausbildung [data]="pruefungDerVariablen.Ausbildung"
    [downloadTxtKey]="'sprint9.cockpit.card.all.tabelle'"
    [columnTxtKey]="'m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.effektiveAusbildung'"
    [tableBottomTxtKey]="'m1-m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table2.hinveise-grundgesamtheit-gueltig-mitarbeiter'"
    [filename]="card.title">
  </app-effektive-ausbildung>
}
<div style="height: 60px"></div>

<!-- table 3 -->
<app-chart-download-button (buttonClick)="downloadTable2()">
  <span class="title" translate>sprint9.cockpit.card.all.tabelle</span>
</app-chart-download-button>

<div class="table-wrapper">
  @if (pruefungDerVariablen) {
    <table class="hover-focus" id="pruefungDerVariablenVerteilungProVariable2M2">
      <thead>
        <tr>
          <th scope="col" class="no-border">&nbsp;</th>
          <th scope="col" rowspan="2" class="header bold centered border-bold-left border-bold-right">
            1
          </th>
          <th scope="col" rowspan="2" class="header bold centered border-bold-left">
            2
          </th>
          <th scope="col" rowspan="2" class="header bold centered border-bold-left">
            3
          </th>
          <th scope="col" rowspan="2" class="header bold centered border-bold-left">
            4
          </th>
          <th scope="col" rowspan="2" class="header bold centered border-bold-left border-bold-right">
            5
          </th>
        </tr>
        <tr>
          <th scope="col" class="header bold centered border-bold-left border-bold-right">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr class="content">
          <th scope="row" class="text-align-left border-bold-right border-bold-left border-bold-right">
          {{'m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.anforderungen-ausbildung'| translate}}</th>
          @for (item of columns; track item) {
            <td class="text-align-right border-bold-right border-bold-left border-bold-right">
              {{item | retrievevalueByIndex: pruefungDerVariablen.anforderungAusbildung}}
            </td>
          }
        </tr>
        <tr class="content">
          <th scope="row" class="text-align-left border-bold-right border-bold-left border-bold-right italic indented">
            {{'m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.effektive-ausbildung-skala'|
            translate}}
          </th>
          @for (item of columns; track item) {
            <td class="text-align-right border-bold-right border-bold-left border-bold-right">
              {{item | retrievevalueByIndex: pruefungDerVariablen.EffektiveAusbildung}}
            </td>
          }
        </tr>
        <tr class="content">
          <th scope="row" class="text-align-left border-bold-right border-bold-left border-bold-right">
          {{'m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.anforderungen-autonomie'| translate}}</th>
          @for (item of columns; track item) {
            <td class="text-align-right border-bold-right border-bold-left border-bold-right">
              {{item | retrievevalueByIndex: pruefungDerVariablen.anforderungAutonomie}}
            </td>
          }
        </tr>
        <tr class="content">
          <th scope="row" class="text-align-left border-bold-right border-bold-left border-bold-right">
            {{'m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.anforderungen-spezifische-fach'| translate}}
          </th>
          @for (item of columns; track item) {
            <td class="text-align-right border-bold-right border-bold-left border-bold-right">
              {{item | retrievevalueByIndex: pruefungDerVariablen.anforderungSpezialwissen}}
            </td>
          }
        </tr>
        <tr class="content">
          <th scope="row" class="text-align-left border-bold-right border-bold-left border-bold-right">
            {{'m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.verantwortungsbezogene-anforder-belastungen'|
          translate}}</th>
          @for (item of columns; track item) {
            <td class="text-align-right border-bold-right border-bold-left border-bold-right">
              {{item | retrievevalueByIndex: pruefungDerVariablen.anforderungVerantwortung}}
            </td>
          }
        </tr>
        <tr class="content">
          <th scope="row" class="text-align-left border-bold-right border-bold-left border-bold-right">
            {{'m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.psychische-soziale-anforder-belastungen'|
          translate}}</th>
          @for (item of columns; track item) {
            <td class="text-align-right border-bold-right border-bold-left border-bold-right">
              {{item | retrievevalueByIndex: pruefungDerVariablen.anforderungPsychosozial}}
            </td>
          }
        </tr>
        <tr class="content">
          <th scope="row" class="text-align-left border-bold-right border-bold-left border-bold-right">
            {{'m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table.koerperliche-anforder-belastungen'|
            translate}}
          </th>
          @for (item of columns; track item) {
            <td class="text-align-right border-bold-right border-bold-left border-bold-right">
              {{item | retrievevalueByIndex: pruefungDerVariablen.anforderungKoerperlich}}
            </td>
          }
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td class="hint" colspan="6" translate>
            m2.sprint7.cockpit.card.chart.pruefung-der-variablen.table3.hinveise-grundgesamtheit-gueltig-mitarbeiter
          </td>
        </tr>
      </tfoot>
    </table>
  }
</div>
